export const triolietNotificationsIconsStyle = {
    '.notification-title': {
        height: 'auto !important',
    },
    '.notification-title::before': {
        display: 'block',
        width: '0.8em',
        height: '0.8em',
        marginTop: '-0.5em',
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '0.75em',
        fontFamily: 'tap',
        fontSize: '1.75em',
        lineHeight: 1,
    },
    '.notification-success .notification-title::before': {
        content: '"\\4d"',
    },
    '.notification-info .notification-title::before': {
        content: '"\\4d"',
    },
    '.notification-error .notification-title::before': {
        content: '"\\34"',
    },
    '.notification-warning .notification-title::before': {
        content: '"\\e022"',
    },
};
//# sourceMappingURL=triolietNotificationsIconsStyle.js.map